import { IRange } from '../../common/types';
import { Region } from '../../utils/regions';
import { Room } from '../filters/model';
import { getLocationId } from './location';
import { ICoordinates, IFinishInfo, IJKData, IPikData, IRoomsInfo, IUndegroundInfo } from '../../../typings/api';

export interface IRoom {
  type: Room;
  minPrice: number;
}

export interface IGk {
  address?: string;
  area: IRange;
  coordinates?: ICoordinates;
  finishInfo?: IFinishInfo;
  finishYears: number[];
  hasDecoration: boolean;
  id: number;
  imgUrl?: string;
  price: IRange;
  promoLabel?: string;
  publicUrl?: string;
  regions: Region[];
  rooms: IRoom[];
  roomsInfo?: IRoomsInfo[];
  bankIds: number[];
  title: string;
  undegroundInfo?: IUndegroundInfo;
}

export function parseRoomType(roomsCount: number): Room {
  switch (roomsCount) {
    case 9:
      return 'studio';
    case 1:
      return 'oneRoom';
    case 2:
      return 'twoRoom';
    case 3:
      return 'threeRoom';
    case 4:
      return 'fourRoom';
    case 5:
      return 'fiveRoom';
    default:
      throw new Error(`Unexpected roomsCount = ${roomsCount}`);
  }
}

function parseRoom(roomInfo: IRoomsInfo): IRoom {
  const type = parseRoomType(roomInfo.roomsCount);
  const minPrice = Number(roomInfo.minPrice);

  return { minPrice: minPrice || 0, type };
}

export function parseGk(pikData: IPikData, gk: IJKData): IGk {
  return {
    address: gk.address,
    area: {
      max: gk.maxArea,
      min: gk.minArea,
    },
    bankIds: gk.bankIds || [],
    coordinates: gk.coordinates,
    finishInfo: gk.finishInfo,
    finishYears: (gk.finishInfo && gk.finishInfo.years) || [],
    hasDecoration: !!gk.hasDecoration,
    id: gk.id,
    imgUrl: gk.imgUrl,
    price: {
      max: gk.maxPrice,
      min: gk.minPrice,
    },
    promoLabel: gk.promoLabel,
    publicUrl: gk.publicUrl,
    regions: pikData.data.locations
      .filter(location => location.jkIds && location.jkIds.includes(gk.id))
      .map(getLocationId)
      .filter(Boolean) as Region[],
    rooms: (gk.roomsInfo && (gk.roomsInfo.map(parseRoom).filter(Boolean) as IRoom[])) || [],
    title: gk.title,
    undegroundInfo: gk.undegroundInfo,
  };
}

export function gkHasData(gk: IGk) {
  return gk.rooms.filter(room => room.minPrice).length > 0;
}

export function mapGKData(pikData: IPikData): IGk[] {
  return pikData.data.jkObjects.map(gk => parseGk(pikData, gk)).filter(gkHasData);
}
